import { render, staticRenderFns } from "./WelcomeSet.vue?vue&type=template&id=6cdc3caa&scoped=true&"
import script from "./WelcomeSet.vue?vue&type=script&lang=js&"
export * from "./WelcomeSet.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeSet.vue?vue&type=style&index=0&id=6cdc3caa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cdc3caa",
  null
  
)

export default component.exports